import { libModelPortfolio } from './index';
export var prefix = 'compositions/';
export var IDToName = function (id) {
    return libModelPortfolio.IDToName(id) + '/' + prefix + id.compositionID;
};
